import React, { useState, useEffect } from 'react';
import apiClient from '../utils/apiClient';

/* =====================================================
   ARRAY NORMALIZER (SAFE)
===================================================== */
const toArray = (v) => {
  if (Array.isArray(v)) return v;
  if (typeof v === 'string') {
    try {
      const p = JSON.parse(v);
      return Array.isArray(p) ? p : [];
    } catch {
      return [];
    }
  }
  return [];
};

const SummaryPage = () => {
  const [summary, setSummary] = useState(null);
  const [form, setForm] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await apiClient.get('/summary');
    setSummary(res.data || null);
    setForm(res.data || {});
    setLoading(false);
  };

  const save = async () => {
    const res = await apiClient.post('/summary', form);
    setSummary(res.data);
    setShowModal(false);
  };

  return (
    <div>

{/* =====================================================
   INLINE CSS (ONLY HERE)
===================================================== */}
<style>{`
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15,23,42,.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  width: 960px;
  max-width: 96%;
  height: 92vh;
  background: #fff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 40px 100px rgba(0,0,0,.45);
}

.modal-header {
  padding: 22px 30px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  padding: 30px;
  overflow-y: auto;
  flex: 1;
}

.modal-footer {
  padding: 16px 30px;
  border-top: 1px solid #eee;
  background: #f8fafc;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  position: sticky;
  bottom: 0;
}

.btn {
  padding: 12px 22px;
  border-radius: 10px;
  border: none;
  font-weight: 700;
  cursor: pointer;
}

.primary { background: #6366f1; color: #fff; }
.secondary { background: #e5e7eb; }

.section {
  margin-bottom: 32px;
}

.section-title {
  font-size: 14px;
  font-weight: 800;
  margin-bottom: 16px;
  color: #334155;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2,1fr);
  gap: 18px;
}

.field {
  display: flex;
  flex-direction: column;
}

.field.full { grid-column: 1 / -1; }

.field label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}

.field input,
.field textarea {
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #cbd5e1;
}

.field textarea {
  min-height: 120px;
}

.profile-card {
  background: #fff;
  border-radius: 20px;
  padding: 28px;
  box-shadow: 0 14px 50px rgba(0,0,0,.08);
  display: grid;
  grid-template-columns: 130px 1fr;
  gap: 26px;
  align-items: center;
}

.avatar {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #6366f1;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.badge {
  background: #eef2ff;
  color: #3730a3;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag {
  background: #e0e7ff;
  color: #3730a3;
  padding: 6px 12px;
  border-radius: 999px;
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 13px;
}

.tag button {
  border: none;
  background: none;
  font-weight: bold;
  cursor: pointer;
}

.tag-input {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.preview-box {
  display: flex;
  align-items: center;
  gap: 16px;
}

.preview-box img {
  width: 90px;
  height: 90px;
  border-radius: 14px;
  object-fit: cover;
  border: 1px solid #ddd;
}
`}</style>

{/* =====================================================
   HEADER
===================================================== */}
      <div className="content-header">
        <h2>Profile Summary</h2>
        <button className="btn primary" onClick={() => setShowModal(true)}>
          ✏️ Edit Summary
        </button>
      </div>

{/* =====================================================
   VIEW MODE
===================================================== */}
      {!loading && summary && (
        <div className="profile-card">

          <img
            className="avatar"
            src={summary.profileImage || 'https://via.placeholder.com/130'}
            alt="Profile"
            onError={(e) => e.target.src = 'https://via.placeholder.com/130'}
          />

          <div>
            <div className='badges'><p className='badge'>{summary.name}</p></div>
            <div className='badges'><p className='badge'>{summary.headline}</p></div>
            <div className='badges'><p className='badge'>{summary.currentLocation}</p></div>
            <div className='badges'><p className='badge'>{summary.subheadline}</p></div>
            
           
          

            <div className="badges">
              {toArray(summary.brands).map((b, i) => (
                <span key={i} className="badge">{b}</span>
              ))}
            </div>
            <div className="badges">
              {toArray(summary.availableForWorkIn).map((b, i) => (
                <span key={i} className="badge">{b}</span>
              ))}
            </div>
            <div className="badges">
              {toArray(summary.jobTypes).map((b, i) => (
                <span key={i} className="badge">{b}</span>
              ))}
            </div>

            <div className="badges">
                {summary.visaSponsorshipRequired ? "🛂 Visa Sponsorship is  Required" : "✅ No Visa Sponsorship Required"}    
            </div>

            {summary.resumeUrl && (
              <div style={{ marginTop: 14 }}>
                <a href={summary.resumeUrl} target="_blank" rel="noreferrer" className="btn secondary">
                  📄 View Resume
                </a>
              </div>
            )}
          </div>

        </div>
      )}

{/* =====================================================
   MODAL
===================================================== */}
{showModal && (
<div className="modal-overlay" onClick={() => setShowModal(false)}>
<div className="modal" onClick={(e) => e.stopPropagation()}>

  <div className="modal-header">
    <h2>Profile Summary</h2>
    <button onClick={() => setShowModal(false)}>✕</button>
  </div>

  <div className="modal-body">

    <div className="section">
      <div className="section-title">Basic Information</div>
      <div className="grid">
        <Field label="Full Name" value={form.name} onChange={v => setForm({...form,name:v})}/>
        <Field label="Location" value={form.currentLocation} onChange={v => setForm({...form,currentLocation:v})}/>
        <Field label="Headline" value={form.headline} onChange={v => setForm({...form,headline:v})}/>
      </div>
    </div>

    <div className="section">
      <div className="section-title">Profile Image</div>
      <div className="preview-box">
        <img src={form.profileImage || 'https://via.placeholder.com/90'} alt="Preview" />
        <input
          placeholder="Image URL"
          value={form.profileImage || ''}
          onChange={(e)=>setForm({...form,profileImage:e.target.value})}
        />
      </div>
    </div>

    <div className="section">
      <div className="section-title">About</div>
      <Textarea label="Summary" value={form.subheadline} onChange={v => setForm({...form,subheadline:v})}/>
    </div>

    <div className="section">
      <div className="section-title">Work Preferences</div>

      <TagEditor label="Brands / Tech Stack" values={toArray(form.brands)} onChange={v => setForm({...form,brands:v})}/>
      <TagEditor label="Job Types" values={toArray(form.jobTypes)} onChange={v => setForm({...form,jobTypes:v})}/>
      <TagEditor label="Available Countries" values={toArray(form.availableForWorkIn)} onChange={v => setForm({...form,availableForWorkIn:v})}/>

      <label style={{ marginTop: 16, display: 'flex', gap: 10 }}>
        <input
          type="checkbox"
          checked={!!form.visaSponsorshipRequired}
          onChange={(e)=>setForm({...form,visaSponsorshipRequired:e.target.checked})}
        />
        Visa sponsorship required
      </label>
    </div>

    <div className="section">
      <div className="section-title">Resume</div>
      <div className="preview-box">
        <input
          placeholder="Resume URL"
          value={form.resumeUrl || ''}
          onChange={(e)=>setForm({...form,resumeUrl:e.target.value})}
        />
        {form.resumeUrl && (
          <a href={form.resumeUrl} target="_blank" rel="noreferrer" className="btn secondary">
            👁 Preview
          </a>
        )}
      </div>
    </div>

  </div>

  <div className="modal-footer">
    <button className="btn secondary" onClick={() => setShowModal(false)}>Cancel</button>
    <button className="btn primary" onClick={save}>💾 Save / Update</button>
  </div>

</div>
</div>
)}

    </div>
  );
};

/* =====================================================
   SMALL REUSABLE UI
===================================================== */

const Field = ({ label, value='', onChange }) => (
  <div className="field">
    <label>{label}</label>
    <input value={value || ''} onChange={(e)=>onChange(e.target.value)} />
  </div>
);

const Textarea = ({ label, value='', onChange }) => (
  <div className="field full">
    <label>{label}</label>
    <textarea value={value || ''} onChange={(e)=>onChange(e.target.value)} />
  </div>
);

const TagEditor = ({ label, values, onChange }) => {
  const [input, setInput] = useState('');

  const add = () => {
    if (!input.trim()) return;
    onChange([...values, input.trim()]);
    setInput('');
  };

  return (
    <div className="field full">
      <label>{label}</label>

      <div className="tags">
        {values.map((v,i)=>(
          <span className="tag" key={i}>
            {v}
            <button onClick={()=>onChange(values.filter((_,idx)=>idx!==i))}>×</button>
          </span>
        ))}
      </div>

      <div className="tag-input">
        <input value={input} onChange={(e)=>setInput(e.target.value)} placeholder="Type and click Add" />
        <button className="btn secondary" onClick={add}>Add</button>
      </div>
    </div>
  );
};

export default SummaryPage;
